function getPayStackKey() {
    if (window.location.hostname === 'localhost') {
      return process.env.REACT_APP_PAYSTACK_PK;
    } else {
      return process.env.REACT_APP_PAYSTACK_LPK;
    }
  }

  export default getPayStackKey